export const AUTH_STATUS = Object.freeze({
  CHECKING: 'checking',
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
});

export const REGISTER_TOKEN = 'register_token';

export const PASSWORD_STRENGTH = ['매우약함', '약함', '보통', '강함', '매우강함'];

export const VERIFICATION_CHANNEL = {
  EMAIL: 'email',
  MOBILE: 'mobile',
};

export const DELIVERY_LABEL = {
  EMAIL: '이메일',
  KAKAO: '카카오톡',
  SMS: '문자메시지',
  RCS: '문자메시지',
}